import styled from '../../../styles/styledComponents/themeComponents';

export const InfiniteRangePickerStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
